<div class="wrapper">
    <app-top-nav></app-top-nav>
    <app-sidebar></app-sidebar>
    <div [ngClass]="( isAuth$ | async)?'contentcontainer':'maincontainer'">
        <router-outlet></router-outlet>
        <app-loader-cmp></app-loader-cmp>
    </div>
    <app-footer [ngClass]="( isAuth$ | async)?'footerwithsidebar':'footerwithoutsidebar'"></app-footer>
</div>